export const LICENSE_TYPE_LABELS_BY_VALUE = {
  "Docs - Internal": "Internal Staff",
  "Docs - Subscription": "Customer",
  "Docs - Trial": "Non-paid Trial",
  Perpetual: "Perpetual",
};

export const licenseTypeLabel = (licenseType) =>
  LICENSE_TYPE_LABELS_BY_VALUE[licenseType] ?? licenseType;

// Perpetual is set outside the product, so it is not offered when assigning a licence.
export const ASSIGNABLE_LICENSE_TYPES = [
  "Docs - Internal",
  "Docs - Subscription",
  "Docs - Trial",
];
